import React from "react";
import { ImageBackground, StyleSheet, View } from "react-native";
import { InspiredBackground } from "./InspiredBackground.js";
import insightNebulaBg from "../assets/insight-nebula-bg.png";

/**
 * Fluid teal shell — background is rendered once at hub root; this wraps slide content only.
 *
 * @param {{ children: React.ReactNode }} props
 */
export function PageBackground({ children }) {
  return <View style={styles.content}>{children}</View>;
}

/** Deep-space nebula backdrop for the Insight tab */
export function InsightPageBackground({ children }) {
  const source = typeof insightNebulaBg === "string" ? { uri: insightNebulaBg } : insightNebulaBg;
  return (
    <ImageBackground source={source} style={styles.insightBg} resizeMode="cover" imageStyle={styles.insightImage}>
      <View style={styles.insightOverlay} pointerEvents="none" />
      <View style={styles.content}>{children}</View>
    </ImageBackground>
  );
}

/** Full-screen fluid backdrop for HomeHubScreen root */
export function AppShellBackground() {
  return <InspiredBackground variant="fluid" />;
}

const styles = StyleSheet.create({
  content: { flex: 1 },
  insightBg: { flex: 1, backgroundColor: "#050A18" },
  insightImage: { width: "100%", height: "100%" },
  insightOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(5, 10, 24, 0.18)",
  },
});
